// Debounce function to limit how often a function is called
function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

function groupItems(parksList, parksItems, countryElementsMap, isCombined) {
  const groupedItems = {
    cz: [],
    pl: [],
    others: [],
  }

  // Group items by data-country attribute
  parksItems.forEach((item) => {
    const country = item.getAttribute("data-country")
    if (country === "cz") {
      groupedItems.cz.push(item)
    } else if (country === "pl") {
      groupedItems.pl.push(item)
    } else {
      groupedItems.others.push(item)
    }
  })

  // Remove all newly added .country-group elements
  document.querySelectorAll(".country-group").forEach((element) => {
    element.remove()
  })

  // Helper function to create and append country group
  function createAndAppendCountryGroup(country, items) {
    if (items.length > 0) {
      const countryGroup = document.createElement("div")
      countryGroup.classList.add("country-group")

      // Move the country-specific element before the parks__list
      const countryElement = document.getElementById(`country-${country}`)
      if (countryElement) {
        countryGroup.appendChild(countryElement)
      }

      const newParksList = document.createElement("div")
      newParksList.classList.add("parks__list")

      const insideDiv = document.createElement("div")
      insideDiv.classList.add("parks__list__inside")

      items.forEach((item) => {
        insideDiv.appendChild(item)
      })

      newParksList.appendChild(insideDiv)
      countryGroup.appendChild(newParksList)

      parksList.parentElement.appendChild(countryGroup)

      // Add scroll event listener to hide/show .ico-swipe__wrapper
      newParksList.addEventListener('scroll', function () {
        const icoSwipeWrapper = newParksList.parentElement.querySelector('.country-group__header .ico-swipe__wrapper')
        if (newParksList.scrollLeft > 10) {
          icoSwipeWrapper.style.display = 'none'
        } else {
          icoSwipeWrapper.style.display = 'block'
        }
      })
    }
  }

  // ARAF: one combined carousel with all parks, no country split
  if (isCombined) {
    createAndAppendCountryGroup("all", parksItems)
    return { all: parksItems }
  }

  // Create and append groups for CZ, PL, and Others
  createAndAppendCountryGroup("cz", groupedItems.cz)
  createAndAppendCountryGroup("pl", groupedItems.pl)
  createAndAppendCountryGroup("others", groupedItems.others)

  return groupedItems
}

function resetItems(parksList, parksItems, groupedItems, countryElementsMap) {
  // Remove all added .country-group elements
  document.querySelectorAll(".country-group").forEach((element) => {
    element.remove()
  })

  // Move country-specific elements back to their original position
  countryElementsMap.forEach((originalParent, countryElement) => {
    try {
      originalParent.appendChild(countryElement)
    } catch (error) {
      console.error("Error moving country element:", error)
    }
  })

  // Clear the parks list if it exists
  if (parksList) {
    parksList.innerHTML = ""
  }

  // Move all items back to the original parksList
  parksItems.forEach((item) => {
    try {
      parksList.appendChild(item)
    } catch (error) {
      console.error("Error moving park item:", error)
    }
  })
}

export default function initPortfolioParks() {
  const parksList = document.querySelector(".parks__list")
  const parksItems = Array.from(document.querySelectorAll(".parks__item"))
  const showMoreBtn = document.querySelector(".parks__btn--more")
  const showLessBtn = document.querySelector(".parks__btn--less")
  let itemsToShow = 3
  const increment = 6
  let isMobileView = window.innerWidth < 1024
  let groupedItems = {}
  const countryElementsMap = new Map()
  const isCombined = !!document.getElementById("country-all")

  function updateItemsVisibility() {
    parksItems.forEach((item, index) => {
      if (index < itemsToShow) {
        item.style.display = "block"
        item.style.height = "";
        item.style.opacity = "1";
      } else {
        item.style.display = "none"
      }
    })

    if (itemsToShow > 3) {
      showLessBtn.style.display = "block"
    } else {
      showLessBtn.style.display = "none"
    }

    if (itemsToShow >= parksItems.length) {
      showMoreBtn.style.display = "none"
    } else {
      showMoreBtn.style.display = "block"
    }
  }

  function toggleShowMore() {
    itemsToShow += increment
    updateItemsVisibility()
  }

  function toggleShowLess() {
    const itemsToHide = Math.min(increment, itemsToShow - 3);
    const itemHeight = parksItems[0].offsetHeight;
    const heightToScroll = itemHeight * 3;
  
    // Scroll up first
    window.scrollBy({
      top: -heightToScroll,
      behavior: "smooth",
    });
  
    // Wait for the scroll to complete before hiding the items
    setTimeout(() => {
      // Animate the items to hide
      for (let i = itemsToShow - 1; i >= itemsToShow - itemsToHide; i--) {
        const item = parksItems[i];
        item.style.height = `${itemHeight}px`; // Set explicit height
        item.style.opacity = "0"; // Fade out
        setTimeout(() => {
          item.style.height = "0"; // Collapse height
        }, 300); // Match the duration of the CSS transition
      }
  
      // Update the itemsToShow after the animation
      setTimeout(() => {
        itemsToShow -= itemsToHide;
        updateItemsVisibility();
      }, 300); // Match the duration of the CSS transition
    }, 300); // Adjust this delay to match the scroll duration
  }

  function setupLayout() {
    isMobileView = window.innerWidth < 1024
    if (isMobileView) {
      groupedItems = groupItems(parksList, parksItems, countryElementsMap, isCombined)
    } else {
      resetItems(parksList, parksItems, groupedItems, countryElementsMap)
    }
  }

  function handleResize() {
    const newIsMobileView = window.innerWidth < 1024
    if (newIsMobileView !== isMobileView) {
      setupLayout()
    }
  }

  const debouncedHandleResize = debounce(handleResize, 250)

  function init() {
    document.querySelectorAll('[id^="country-"]').forEach((element) => {
      countryElementsMap.set(element, element.parentElement)
    })
    setupLayout()
    window.addEventListener("resize", debouncedHandleResize)
  }

  if (showMoreBtn) {
    showMoreBtn.addEventListener("click", (event) => {
      event.preventDefault()
      const wrapper = document.querySelector(".portfolio-parks__wrapper")
      if (!wrapper.classList.contains("padding-added")) {
        wrapper.style.paddingBottom = "6rem"
        wrapper.classList.add("padding-added")
      }
      toggleShowMore()
    })
  }

  if (showLessBtn) {
    showLessBtn.addEventListener("click", (event) => {
      event.preventDefault()
      const wrapper = document.querySelector(".portfolio-parks__wrapper")
      const items = document.querySelectorAll(".portfolio-parks__item")
      if (items.length <= 3) {
        wrapper.style.paddingBottom = "0"
        wrapper.classList.remove("padding-added")
      }
      toggleShowLess()
    })
  }

  init()
}
